// Navigation utility that works both inside and outside React components
// Since the app uses HashRouter, we can manipulate the hash directly

export const navigateToLogin = () => {
  // For HashRouter, we can change the hash without triggering a full page reload
  if (window.location.hash !== '#/login') {
    window.location.hash = '#/login';
  }
};

export const navigateToPath = (path) => {
  const targetHash = `#${path}`;
  if (window.location.hash !== targetHash) {
    window.location.hash = targetHash;
  }
};

// Alternative method using window.history.pushState for cleaner navigation
export const navigateWithoutReload = (path) => {
  try {
    // Try to use history API first (cleaner)
    if (window.history && window.history.pushState) {
      const targetHash = `#${path}`;
      if (window.location.hash !== targetHash) {
        window.location.hash = targetHash;
      }
    } else {
      // Fallback to direct hash manipulation
      navigateToPath(path);
    }
  } catch (error) {
    console.warn('Navigation error:', error);
    // Last resort fallback
    window.location.hash = `#${path}`;
  }
};
